const $ = window.$;



export default class Factory {
  constructor() {
    this.bindEvents();
    this.startSlider();
  }



  bindEvents() {
    $('#js-factory-anchor').on('click', (e) => {
      e.preventDefault();
      this.onScroll();
    });

    $('.js-factory-reserve').on('click', () => {
      this.onClickClip();
    });
  }



  startSlider() {
    $('.p-factory-contents__photo').slick({
      autoplay: true,
      dots: true,
    });
  }


  onScroll() {
    const accessPos = $('#js-factory-access').offset().top;
    const headHeight = $('#js-header').height();
    const margin = -20;

    $('html, body').animate({
      scrollTop: accessPos - (headHeight - margin)
    })
  }

}


/** WEBPACK FOOTER **
 ** ./htdocs_dev/js/view/factory.js
 **/